export const SCHEDULED_TASKS_RESET_STATE = 'SCHEDULED_TASKS_RESET_STATE';
export const SCHEDULED_TASKS_CURRENT_ITEM = 'SCHEDULED_TASKS_CURRENT_ITEM';

export const SCHEDULED_TASKS_REQUEST_LOADING = 'SCHEDULED_TASKS_REQUEST_LOADING';
export const SCHEDULED_TASKS_REQUEST_SUCCESS = 'SCHEDULED_TASKS_REQUEST_SUCCESS';
export const SCHEDULED_TASKS_REQUEST_FAILED = 'SCHEDULED_TASKS_REQUEST_FAILED';

export const SCHEDULED_TASKS_CURRENT_ACTION = 'SCHEDULED_TASKS_CURRENT_ACTION';
export const SCHEDULED_TASKS_RESET_ACTION = 'SCHEDULED_TASKS_RESET_ACTION';